<template>
<!--  合同结算-->
<div style="width:100%;padding-top: 60px">
  <div style="position: fixed; top: 0; z-index: 999; width: 100%;">
    <div style="text-align:center">
      <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理</van-button>
      <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
    </div>

    <div class="doTask" v-if="isshow">
      <div>
        <van-field name="radio" label="审批意见">
          <template #input>
            <van-radio-group v-model="auditForm.status" direction="horizontal">
              <van-radio name="同意">同意</van-radio>
              <van-radio name="不同意">不同意</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </div>
      <div>
        <van-cell-group>
          <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
        </van-cell-group>
      </div>
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
      </div>
    </div>
  </div>

  <van-collapse v-model="activeNames">
    <van-collapse-item title="合同信息" name="1">
      <van-field v-model="inputForm.contractCode" label="合同编号" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.contractName" label="合同名称" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.budgetItemsName" label="所属项目" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.contractTypeName" label="合同分类" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.contractPartyYiSupplierName" label="合同乙方" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.contractorManagerName" label="承包单位负责人" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-show="inputForm.contractCategory === '1'" v-model="inputForm.jiaSupplierMaterialAmount" :formatter="formatterNumber" label="甲供材金额(元)" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.contractSettlementAmount" label="合同金额(元)" :formatter="formatterNumber" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.paidAmount" label="累计已付款金额(元)" :formatter="formatterNumber" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.unpaidAmount" label="未付款金额(元)" :formatter="formatterNumber" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
    </van-collapse-item>
    <van-collapse-item title="结算信息" name="2">
      <van-field v-model="inputForm.settlementCode" label="结算单编号" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.approvalAmount" label="报审金额(元)" :formatter="formatterNumber" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.contractSettlementAmount" label="结算金额(元)" :formatter="formatterNumber" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.settlementAdjustAmount" label="结算调整金额(元)" :formatter="formatterNumber" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-show="inputForm.contractCategory === '1'" v-model="inputForm.yiExcessJiaSupplierMaterialAmount" :formatter="formatterNumber" label="乙方超领甲供材金额(元)" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-show="inputForm.contractCategory === '1'" v-model="inputForm.constructionUtilitiesAmount" :formatter="formatterNumber" label="施工水电费(元)" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.otherAmount" label="其他扣款(元)" :formatter="formatterNumber" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.settlementPayableAmount" label="结算实际应付金额(元)" :formatter="formatterNumber" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.operatorName" label="经办人" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.operatorDeptName" label="经办部门" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-show="inputForm.contractCategory !== '4'" v-model="inputForm.warrantyRatio" label="质保金比例" :formatter="formatterNumber" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-show="inputForm.contractCategory !== '4'" v-model="inputForm.warrantySettlementAmount" label="质保金金额(元)" :formatter="formatterNumber" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-show="inputForm.warrantySettlementAmount != 0 && inputForm.warrantySettlementAmount !== undefined" v-model="inputForm.warrantyAgreement" label="质保约定" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-show="inputForm.warrantySettlementAmount != 0 && inputForm.warrantySettlementAmount !== undefined" v-model="inputForm.warrantyDateStart" label="质保开始时间" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-show="inputForm.warrantySettlementAmount != 0 && inputForm.warrantySettlementAmount !== undefined" v-model="inputForm.warrantyDateEnd" label="质保结束时间" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.remarks" label="合同结算说明" label-width="120px" readonly input-align="left" :border="false" autosize type="textarea" />
      <div style="padding-left: 16px;" v-show="inputForm.generalAttachList.length > 0">
        <p>附件</p>
        <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.generalAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
      </div>
    </van-collapse-item>
    <van-collapse-item title="付款计划调整明细" name="3">
      <van-field v-model="inputForm.budgetControlName" label="预算控制" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-if="inputForm.budgetControl === '2'" v-model="inputForm.specialBudgetItemsName" label="专项预算项目" label-width="120px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <div v-for="(data, index) in inputForm.paymentPlanDetailList" :key="index" style="margin-bottom: 10px">
        <!--          <div class="m-row">-->
        <!--            <div class="m-row-text">序号</div>-->
        <!--            <div class="m-row-content">{{ index }}</div>-->
        <!--          </div>-->
        <div class="m-form">
          <div class="m-row" v-if="inputForm.budgetControl === '1'">
            <div class="m-row-text">预算年度</div>
            <div class="m-row-content">{{ data.adjustmentBudgetAnnualName }}</div>
          </div>
          <div class="m-row" v-if="inputForm.budgetControl === '1'">
            <div class="m-row-text">预算科目名称</div>
            <div class="m-row-content">{{ data.adjustmentBudgetSubjectFullName }}</div>
          </div>
          <div class="m-row">
            <div class="m-row-text">款项类型</div>
            <div class="m-row-content">{{ data.paymentType === '2' ? '进度款' : '质保金' }}</div>
          </div>
          <div class="m-row">
            <div class="m-row-text">付款条件</div>
            <div class="m-row-content large-content">{{ data.paymentClause }}</div>
          </div>
          <div class="m-row">
            <div class="m-row-text">应付时间</div>
            <div class="m-row-content">{{ data.planDate }}</div>
          </div>
          <div class="m-row">
            <div class="m-row-text">资金计划时间</div>
            <div class="m-row-content">{{ data.fundsPlanDate }}</div>
          </div>
          <div class="m-row">
            <div class="m-row-text">原付款比例(%)</div>
            <div class="m-row-content">{{ Number(data.paymentRatio).toFixed(2) }}</div>
          </div>
          <div class="m-row">
            <div class="m-row-text">原付款金额(元)</div>
            <div class="m-row-content">{{ Number(data.planAmount).toFixed(2) }}</div>
          </div>
          <div class="m-row">
            <div class="m-row-text">调整后付款比例(%)</div>
            <div class="m-row-content">{{ Number(data.adjustmentPaymentRatio).toFixed(2) }}</div>
          </div>
          <div class="m-row">
            <div class="m-row-text">调整后付款金额(元)</div>
            <div class="m-row-content">{{ Number(data.adjustmentPlanAmount).toFixed(2) }}</div>
          </div>
          <div class="m-row">
            <div class="m-row-text">备注</div>
            <div class="m-row-content large-content">{{ data.remarks }}</div>
          </div>
        </div>
      </div>
    </van-collapse-item>
  </van-collapse>
  <process-record :procInsId="procInsId"></process-record>
</div>
</template>

<script>
import processRecord from "../../../../components/processRecord/processRecord";
import Decimal from "decimal.js";
import TaskService from "../../../../api/flowable/TaskService";
import ProcessService from "../../../../api/flowable/ProcessService";
import Vue from "vue";
import flowSettingService from "../../../../api/sys/flowSettingService";
export default {
  name: "contractSettlement",
  data(){
    return {
      activeNames: ['1', '2', '3'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type:'',
      subjectTypeList: [],
      activeName: '',
      inputForm:{
        generalAttachList: []
      }
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.inputForm.id = id
      this.$flow.queryById(id, '/contract/costContractSettlement/queryById').then(({ data }) => {
        this.inputForm = data
        this.inputForm.createDate =  this.inputForm.createDate.slice(0,10)
        this.inputForm.budgetControlName = this.inputForm.budgetControl === '1' ? '年度预算' : this.inputForm.budgetControl === '2' ? '专项预算' : '无预算'
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(async () => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        // vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        let sendBy = ''
        let sendByDeptId = ''
        let sendByCompanyId = ''
        if(this.inputForm.flowStatus === 1) {
          sendBy = Vue.cookie.get('userId');
          const res1 = await new flowSettingService().queryUser(sendBy)
          sendByDeptId = res1.data.officeDTO.id
          sendByCompanyId = res1.data.companyDTO.id
        } else {
          const res3 = await new TaskService().queryByProcInsId(this.inputForm.procInsId)
          sendBy = res3.data.createBy
          sendByDeptId = res3.data.createDept
          sendByCompanyId = res3.data.createCompany
        }
        let createByDeptId = ''
        let createByCompanyId = ''
        const res2 = await new flowSettingService().queryUser(this.inputForm.createById)
        createByDeptId = res2.data.officeDTO.id
        createByCompanyId = res2.data.companyDTO.id
        // vars = { ...vars, ..._this.inputForm }
        vars = {
          sendBy: sendBy,
          sendByDeptId: sendByDeptId,
          sendByCompanyId: sendByCompanyId,
          createByDeptId: createByDeptId,
          createByCompanyId: createByCompanyId,
          createBy: this.inputForm.createById,
          contractCategory: this.inputForm.contractCategory,
          operatorId: this.inputForm.operatorId,
          operatorDeptId: this.inputForm.operatorDeptId,
          paymentCompanyId: this.inputForm.contractPartyJiaId
        }
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey
          }
          // _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(form, '/contract/costContractSettlement/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          // _this.inputForm.flowType = 3;
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey
          }
          _this.$flow.startFlow(form, '/contract/costContractSettlement/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    formatterNumber(value){
      return Number(value).toFixed(2)
    },
    formatterYN(value){
      return value === '1'? '是' : '否'
    },
    // 将数字转为大写
    numberToChinese(Amount) {
      if (Amount === 0) {
        return '零圆'
      }
      let amount = Math.abs(Amount)
      let tempAmount = ''
      if (amount !== '' && amount != null && amount !== '0') {
        let unit = '仟佰拾亿仟佰拾万仟佰拾圆角分'
        let str = ''
        amount += '00'
        const point = amount.indexOf('.')
        if (point >= 0) {
          amount = amount.substring(0, point) + amount.substr(point + 1, 2)
        }
        unit = unit.substr(unit.length - amount.length)
        for (let i = 0; i < amount.length; i++) {
          str += '零壹贰叁肆伍陆柒捌玖'.charAt(amount.charAt(i)) + unit.charAt(i)
        }
        tempAmount = str.replace(/零(仟|佰|拾|角)/g, '零')
            .replace(/(零)+/g, '零')
            .replace(/零(万|亿|圆)/g, '$1')
            .replace(/(亿)万|(拾)/g, '$1$2')
            .replace(/^圆零?|零分/g, '')
            .replace(/元$/g, '圆');
      }
      if (Amount < 0) {
        tempAmount = '负' + tempAmount
      }
      return tempAmount;
    },
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.unitTitle {
  width: 100%;
  padding-left: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}
.m-form {
  width: 100%;
  /*padding: 10px;*/
  font-size: 12px;
  box-sizing: border-box;
  /*border-bottom: 1px solid #eee;*/
  padding-left: 16px;
  margin-bottom: 10px;
}
.title {
  width: calc(100vw - 20px);
  height: 30px;
  background-color: #eeeeee;
  line-height: 30px;
  font-weight: bold;
  padding-left: 5px;
  box-sizing: border-box;
  /*// margin-bottom: 20rpx;*/
}

.m-row {
  display: flex;
  width: calc(100%);
  border: 1px solid #eee;
  border-bottom: 0px;
}

.m-row:last-child {
  border-bottom: 1px solid #eee;
}

.m-row-text {
  width: 110px;
  padding-left: 5px;
  border-right: 1px solid #eee;
  /*border-bottom: 1px solid #eee;*/
  display: flex;
  align-items: center;
  /*background-color: #dedede;*/
}

.m-row-content {
  width: calc(100% - 110px);
  color: black;
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
}

.large-content {
  width: calc(100% - 110px);
  min-height: 30px;
  height: auto;
  padding-left: 10px;
  overflow: hidden;
}
</style>